class RecoverForm extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.button = this.querySelector('button[name="submit"]');
        this.error = this.querySelector('.global-message');
        this.errorContent = this.querySelector('.global-message__copy');
        this.button.addEventListener('click', this.buttonClick.bind(this));
    }

    buttonClick(event) {
        this.loadingSpinner = this.querySelector('.generic-form__spinner');
        this.loadingSpinner.classList.remove('hidden');

        this.handleValidation(event);
        if (this.hasValidated) {
            fetch(getGlobalDomain('/apps/bat-enhanced/customer/reset-password'), {
                method: 'POST',
                body: new URLSearchParams(new FormData(this.form)),
                headers: {
                    'X-Shopify-Country': window.Shopify.country,
                    'X-Shopify-Language': window.Shopify.locale,
                }
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.ok) {
                        this.error.classList.remove('global-message--error', 'global-message--success')
                        this.errorContent.innerHTML = '';
                        this.errorContent.append(this.generateSuccessMessage());
                        this.error.classList.add('global-message--success', 'global-message--active');
                        this.loadingSpinner.classList.add('hidden');
                    } else {
                        this.errorContent.innerHTML = '';
                        this.errorContent.append(this.generateErrorMessage());
                        this.error.classList.add('global-message--error', 'global-message--active');
                        this.loadingSpinner.classList.add('hidden');
                    }
                })
                .catch((error) => {
                    this.errorContent.innerHTML = '';
                    this.errorContent.append(this.generateErrorMessage());
                    this.error.classList.add('global-message--error', 'global-message--active');
                    this.loadingSpinner.classList.add('hidden');
                    console.error(error);
                })
                .finally(() => {
                    this.error?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                });
        } else {
            this.errorContent.innerHTML = '';
            this.errorContent.append(this.generateErrorMessage());
            this.error.classList.add('global-message--error', 'global-message--active');
            this.loadingSpinner.classList.add('hidden');
        }
    }

    generateErrorMessage() {
        const locales = window.loginSidebarStrings.recoverErrorMsg;
        const errorMessage = document.createElement('SPAN');
        errorMessage.append(`${locales}`);
        return errorMessage;
    }

    generateSuccessMessage() {
        const locales = window.loginSidebarStrings.recoverSuccessMsg;
        const successMessage = document.createElement('SPAN');
        successMessage.append(`${locales}`);
        return successMessage;
    }
}

customElements.define('recover-form', RecoverForm);
